import Joi from "joi";

export const vendorStatusSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
});
